import React from 'react';
import '../styles/Projects.css';
import Button from './Button';

const ProjectCard = ({ project }) => {
  return (
    <div className="project bg-white p-4 rounded shadow flex flex-col gap-4">
      <div>
        <h3 className="text-xl font-semibold">{project.title}</h3>
        <h4 className="text-md text-gray-500">{project.subtitle}</h4>
      </div>

      <p className="text-gray-700">{project.description}</p>

      <div className="flex justify-center items-center overflow-hidden rounded">
        <img
          src={project.img}
          alt={project.title}
          className="h-64 w-full object-cover"
        />
      </div>

      <div className="flex justify-center">
        <Button
          className="button-primary"
          onClick={() => window.open(project.link, "_blank", "noopener noreferrer")}
        >
          Learn More
        </Button>
      </div>
    </div>

  );
};

export default ProjectCard;

